import { fromJS } from "immutable";
import ACTIONS from "../constants";

const initialState = fromJS({
  error: "",
  risks: [],
  riskStatusLoading: false,
  riskPagination: {},
  riskLoading: false,
});

export default function riskReducer(state = initialState, action) {
  switch (action.type) {
    //GET RISKS
    case ACTIONS.RISK.PENDING: {
      return state.set("error", "").set("riskLoading", true);
    }

    case ACTIONS.RISK.SUCCESS: {
      return state
        .set("riskLoading", false)
        .set("error", "")
        .set("risks", action.data.data)
        .set("riskPagination", action.data.pagination);
    }

    case ACTIONS.RISK.ERROR: {
      return state.set("riskLoading", false).set("error", action.error);
    }

    //update risk
    case ACTIONS.UPDATE_RISK.PENDING: {
      return state.set("riskStatusLoading", true);
    }
    case ACTIONS.UPDATE_RISK.SUCCESS: {
      return state
        .set("riskStatusLoading", false)
        .set("error", "")
        .set("risks", action.data.data)
        .set("riskPagination", action.data.pagination);
    }
    case ACTIONS.UPDATE_RISK.ERROR: {
      return state.set("error", action.error).set("riskStatusLoading", false);
    }

    //create Risk
    case ACTIONS.CREATE_RISK.PENDING: {
      return state.set("riskStatusLoading", true).set("error", "");
    }
    case ACTIONS.CREATE_RISK.SUCCESS: {
      return state
        .set("riskStatusLoading", false)
        .set("error", "")
        .set("risks", action.data.data)
        .set("riskPagination", action.data.pagination);
    }
    case ACTIONS.CREATE_RISK.ERROR: {
      return state.set("error", action.error).set("riskStatusLoading", false);
    }

    // delete risk
    case ACTIONS.DELETE_RISK.PENDING: {
      return state.set("riskStatusLoading", true);
    }
    case ACTIONS.DELETE_RISK.SUCCESS: {
      return state
        .set("riskStatusLoading", false)
        .set("error", "")
        .set("risks", action.data.data)
        .set("riskPagination", action.data.pagination);
    }
    case ACTIONS.DELETE_RISK.ERROR: {
      return state.set("riskStatusLoading", false).set("error", action.error);
    }

    // Sort Risks
    case ACTIONS.SORT_RISKS.PENDING: {
      return state.set("error", "");
    }
    case ACTIONS.SORT_RISKS.SUCCESS: {
      return state
        .set("error", "")
        .set("risks", action.data.data)
        .set("riskPagination", action.data.pagination);
    }
    case ACTIONS.SORT_RISKS.ERROR: {
      return state.set("error", action.error);
    }

    default: {
      return state;
    }
  }
}
